module.exports = __webpack_public_path__ + "media/20250530.d0a89f59.mp4";